(() => {
  if (customElements.get('product-sticky-cart')) return;
  customElements.define('product-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.tos-sticky-add-to-cart__button');
      this.targetButton = document.getElementById(this.dataset.targetButtonId);
      this.product = this.closest('product-info');
      if (!this.button || !this.targetButton || !this.product) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.button.addEventListener('click', () => {
        if (!this.targetButton.disabled && this.targetButton.getAttribute('aria-disabled') !== 'true') this.targetButton.click();
      }, options);
      this.querySelector('[data-sticky-edit]').addEventListener('click', () => {
        const picker = this.product.querySelector('variant-selects');
        const target = picker || this.targetButton;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        const control = picker?.querySelector('input:checked, select, input') || this.targetButton;
        control.focus({ preventScroll: true });
      }, options);
      this.observer = new IntersectionObserver(() => this.sync(), { threshold: [0, .35, 1] });
      this.observer.observe(this.targetButton);
      this.stateObserver = new MutationObserver(() => this.sync());
      this.stateObserver.observe(this.targetButton, { attributes: true, childList: true, subtree: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      const price = this.product.querySelector('[id^="price-"]');
      if (price) this.stateObserver.observe(price, { childList: true, subtree: true, attributes: true });
      this.product.addEventListener('change', () => this.sync(), options);
      this.overlayObserver = new MutationObserver(records => {
        if (records.some(record => record.target.matches?.('dialog,cart-drawer,cart-notification,.cart-notification,modal-dialog,quick-add-modal,[role="dialog"],body,details') || [...record.addedNodes].some(node => node.matches?.('dialog,[role="dialog"]')))) this.sync();
      });
      this.overlayObserver.observe(document.body, { attributes: true, childList: true, subtree: true, attributeFilter: ['open', 'class', 'hidden', 'aria-hidden'] });
      this.hidden = false;
      this.sync();
    }
    sync() {
      const busy = this.targetButton.classList.contains('loading');
      const disabled = this.targetButton.disabled || this.targetButton.getAttribute('aria-disabled') === 'true';
      const text = this.targetButton.querySelector('span')?.textContent.trim();
      if (text && this.button.querySelector('span').textContent !== text) this.button.querySelector('span').textContent = text;
      this.button.disabled = disabled;
      this.button.setAttribute('aria-busy', String(busy));
      this.classList.toggle('is-busy', busy);
      const price = this.product.querySelector('[id^="price-"] .price');
      const currentPrice = price?.querySelector(price.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
      if (currentPrice) this.querySelector('[data-sticky-price]').textContent = currentPrice.textContent.trim();
      const selections = [...new Set([...this.product.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.value).filter(Boolean))];
      this.querySelector('[data-sticky-options]').textContent = selections.join(' / ');
      this.querySelector('[data-sticky-edit]').hidden = !selections.length;
      const overlays = document.querySelectorAll('dialog[open],cart-drawer.active,.cart-notification.active,modal-dialog[open],quick-add-modal[open],[role="dialog"][aria-modal="true"]:not([hidden]):not([aria-hidden="true"])');
      const overlayVisible = [...overlays].some(overlay => overlay.getClientRects().length && getComputedStyle(overlay).visibility !== 'hidden' && getComputedStyle(overlay).opacity !== '0' && !overlay.closest('details:not([open])'));
      const visible = this.targetButton.getBoundingClientRect().bottom <= 0 && (!disabled || busy) && !overlayVisible;
      this.classList.toggle('is-visible', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.stateObserver?.disconnect();
      this.overlayObserver?.disconnect();
    }
  });
})();
